import { useEffect, useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

const GRUPOS_PERMISSAO = [
  {
    grupo: 'Processos', icone: '📋',
    permissoes: [
      { key:'ver_processos_setor',  label:'Ver processos do seu setor' },
      { key:'ver_todos_processos',  label:'Ver todos os processos' },
      { key:'abrir_processo',       label:'Abrir novo processo' },
      { key:'tramitar_processo',    label:'Tramitar e despachar processos' },
      { key:'concluir_processo',    label:'Concluir e arquivar processos' },
    ]
  },
  {
    grupo: 'Pessoas', icone: '👤',
    permissoes: [
      { key:'ver_usuarios',     label:'Ver usuários do sistema' },
      { key:'criar_usuarios',   label:'Criar e editar usuários' },
      { key:'ver_cidadaos',     label:'Ver cidadãos cadastrados' },
      { key:'aprovar_cidadaos', label:'Aprovar ou rejeitar cadastros de cidadãos' },
    ]
  },
  {
    grupo: 'Portais e atendimento', icone: '🏢',
    permissoes: [
      { key:'atendimento_presencial', label:'Atendimento presencial no balcão' },
      { key:'aprovacoes',             label:'Aprovar triagens e aprovações hierárquicas' },
    ]
  },
  {
    grupo: 'Configurações do sistema', icone: '⚙️',
    permissoes: [
      { key:'secretarias',    label:'Gerenciar secretarias e departamentos' },
      { key:'tipos_processo', label:'Gerenciar tipos de processo' },
      { key:'modelos_texto',  label:'Gerenciar modelos de texto' },
      { key:'auditoria',      label:'Ver trilha de auditoria' },
      { key:'configuracoes',  label:'Configurações do órgão' },
    ]
  },
]

const TOTAL_DISPONIVEL = GRUPOS_PERMISSAO.reduce((acc,g) => acc+g.permissoes.length, 0)

// ── Componente do formulário FORA do componente pai ──
function FormPerfil({ form, onChange, onToggle, onToggleGrupo, onMarcarTudo, onSalvar, onCancelar, editando, erro }) {
  const totalSelecionado = Object.values(form.permissoes).filter(Boolean).length

  return (
    <div style={{ display:'grid', gridTemplateColumns:'300px 1fr', gap:20 }}>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20, alignSelf:'start' }}>
        <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>{editando ? 'Editar perfil' : 'Novo perfil'}</div>

        <div style={{ marginBottom:12 }}>
          <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Nome do perfil *</label>
          <input
            value={form.nome}
            onChange={e => onChange('nome', e.target.value)}
            placeholder="Ex: Chefe de setor"
            style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }}
          />
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Descrição</label>
          <input
            value={form.descricao}
            onChange={e => onChange('descricao', e.target.value)}
            placeholder="Para que serve este perfil"
            style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }}
          />
        </div>

        <div style={{ background:'#f9fafb', borderRadius:8, padding:12, marginBottom:12 }}>
          <div style={{ fontSize:12, color:'#6b7280', marginBottom:2 }}>Permissões selecionadas</div>
          <div style={{ fontSize:22, fontWeight:600, color:'#185FA5' }}>
            {totalSelecionado} <span style={{ fontSize:13, fontWeight:400, color:'#9ca3af' }}>de {TOTAL_DISPONIVEL}</span>
          </div>
        </div>

        <div style={{ display:'flex', gap:6, marginBottom:16 }}>
          <button onClick={() => onMarcarTudo(true)} style={{ flex:1, padding:'6px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>
            Marcar tudo
          </button>
          <button onClick={() => onMarcarTudo(false)} style={{ flex:1, padding:'6px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>
            Desmarcar tudo
          </button>
        </div>

        {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:10 }}>{erro}</div>}

        <div style={{ display:'flex', gap:8 }}>
          <button onClick={onSalvar} style={{ flex:1, padding:9, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            {editando ? 'Salvar' : 'Criar perfil'}
          </button>
          <button onClick={onCancelar} style={{ padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
            Cancelar
          </button>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {GRUPOS_PERMISSAO.map(grupo => {
          const todasMarcadas = grupo.permissoes.every(p => form.permissoes[p.key])
          const algunsMarcados = grupo.permissoes.some(p => form.permissoes[p.key])
          const countMarcadas = grupo.permissoes.filter(p => form.permissoes[p.key]).length

          return (
            <div key={grupo.grupo} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
              <div
                style={{ padding:'12px 20px', borderBottom:'1px solid #f3f4f6', display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}
                onClick={() => onToggleGrupo(grupo)}
              >
                <span style={{ fontSize:16 }}>{grupo.icone}</span>
                <div style={{ flex:1, fontSize:13, fontWeight:500 }}>{grupo.grupo}</div>
                <span style={{ fontSize:11, color:'#9ca3af' }}>{countMarcadas}/{grupo.permissoes.length}</span>
                <div style={{
                  width:18, height:18, borderRadius:4, flexShrink:0,
                  border:`2px solid ${todasMarcadas||algunsMarcados?'#185FA5':'#d1d5db'}`,
                  background:todasMarcadas?'#185FA5':algunsMarcados?'#E6F1FB':'white',
                  display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:'white'
                }}>
                  {todasMarcadas ? '✓' : algunsMarcados ? '—' : ''}
                </div>
              </div>
              <div style={{ padding:'8px 0' }}>
                {grupo.permissoes.map(p => (
                  <div
                    key={p.key}
                    onClick={() => onToggle(p.key)}
                    style={{ display:'flex', alignItems:'center', gap:12, padding:'8px 20px', cursor:'pointer' }}
                    onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}
                  >
                    <div style={{
                      width:18, height:18, borderRadius:4, flexShrink:0,
                      border:`2px solid ${form.permissoes[p.key]?'#185FA5':'#d1d5db'}`,
                      background:form.permissoes[p.key]?'#185FA5':'white',
                      display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:'white'
                    }}>
                      {form.permissoes[p.key] ? '✓' : ''}
                    </div>
                    <span style={{ fontSize:13, color:'#374151' }}>{p.label}</span>
                  </div>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// ── Componente principal ──
export default function Perfis() {
  const [lista, setLista] = useState([])
  const [form, setForm] = useState({ nome:'', descricao:'', permissoes:{} })
  const [editando, setEditando] = useState(null)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [tela, setTela] = useState('lista') // lista | form

  useEffect(() => { carregar() }, [])

  async function carregar() {
    try { const r = await api.get('/perfis'); setLista(r.data) } catch {}
  }

  function onChange(campo, valor) {
    setForm(f => ({ ...f, [campo]: valor }))
  }

  function onToggle(key) {
    setForm(f => ({ ...f, permissoes: { ...f.permissoes, [key]: !f.permissoes[key] } }))
  }

  function onToggleGrupo(grupo) {
    const keys = grupo.permissoes.map(p => p.key)
    const todasMarcadas = keys.every(k => form.permissoes[k])
    const novas = { ...form.permissoes }
    keys.forEach(k => { novas[k] = !todasMarcadas })
    setForm(f => ({ ...f, permissoes: novas }))
  }

  function onMarcarTudo(marcar) {
    const novas = {}
    GRUPOS_PERMISSAO.forEach(g => g.permissoes.forEach(p => { novas[p.key] = marcar }))
    setForm(f => ({ ...f, permissoes: novas }))
  }

  function abrirNovo() {
    setForm({ nome:'', descricao:'', permissoes:{} })
    setEditando(null); setErro(''); setTela('form')
  }

  function abrirEditar(p) {
    setEditando(p.id)
    setForm({ nome:p.nome, descricao:p.descricao||'', permissoes:p.permissoes||{} })
    setErro(''); setTela('form')
  }

  async function salvar() {
    if (!form.nome) { setErro('Nome é obrigatório'); return }
    setErro('')
    try {
      if (editando) { await api.put(`/perfis/${editando}`, form); setSucesso('Perfil atualizado!') }
      else { await api.post('/perfis', form); setSucesso('Perfil criado!') }
      setTela('lista'); carregar()
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
  }

  async function remover(id) {
    if (!window.confirm('Remover este perfil?')) return
    try { await api.delete(`/perfis/${id}`); carregar() }
    catch(e) { alert(e.response?.data?.erro || 'Erro ao remover') }
  }

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 4px' }}>Perfis de acesso</h1>
          <div style={{ fontSize:13, color:'#9ca3af' }}>Crie perfis com permissões específicas e atribua aos usuários</div>
        </div>
        {tela === 'lista' && (
          <button onClick={abrirNovo} style={{ padding:'8px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            + Novo perfil
          </button>
        )}
      </div>

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

      {tela === 'form' && (
        <FormPerfil
          form={form}
          onChange={onChange}
          onToggle={onToggle}
          onToggleGrupo={onToggleGrupo}
          onMarcarTudo={onMarcarTudo}
          onSalvar={salvar}
          onCancelar={() => setTela('lista')}
          editando={editando}
          erro={erro}
        />
      )}

      {tela === 'lista' && (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {lista.length === 0
            ? <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:40, textAlign:'center', color:'#9ca3af', fontSize:14 }}>
                Nenhum perfil cadastrado. Crie o primeiro perfil.
              </div>
            : lista.map(p => {
              const totalP = Object.values(p.permissoes||{}).filter(Boolean).length
              return (
                <div key={p.id} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:'16px 20px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <div style={{ width:40, height:40, borderRadius:8, background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:700, color:'#185FA5', flexShrink:0 }}>
                      {p.nome.substring(0,2).toUpperCase()}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:500 }}>{p.nome}</div>
                      <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>
                        {p.descricao || 'Sem descrição'} · {totalP} permissão{totalP!==1?'ões':''} · {p.total_usuarios} usuário{p.total_usuarios!==1?'s':''}
                      </div>
                      <div style={{ display:'flex', gap:4, marginTop:8, flexWrap:'wrap' }}>
                        {GRUPOS_PERMISSAO.map(g => {
                          const count = g.permissoes.filter(perm => p.permissoes?.[perm.key]).length
                          if (count === 0) return null
                          return (
                            <span key={g.grupo} style={{ background:'#f3f4f6', color:'#374151', fontSize:11, padding:'2px 8px', borderRadius:99 }}>
                              {g.icone} {g.grupo}: {count}/{g.permissoes.length}
                            </span>
                          )
                        })}
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                      <button onClick={() => abrirEditar(p)} style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Editar</button>
                      <button onClick={() => remover(p.id)} style={{ padding:'6px 10px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>Remover</button>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      )}
    </Layout>
  )
}
